<template>
  <chart-container :titleChart="titleChart" @onCSVDownload="downloadCSVGraphs()" @zoomEnabled="zoomGraph(true)" @zoomDisabled="zoomGraph(false)" :downloadId="containerId" :specificSiteId="specificSiteId" :zoomGraphValue="zoomGraphValue" :downloadShow="enrollChartData.dataset && Object.keys(enrollChartData.dataset).length > 0">
    <span slot="header" class="float-right enrol-tabs">
      <b-tabs v-model="tabIndex">
        <b-tab v-for="tabName in tabList" :key="tabName" :title="tabName" />
      </b-tabs>
    </span>
    <div class="total-count" v-if="dataLoaded && showTotalParticipant" slot="subheader">
      {{ enrollChartData ? enrollChartData.totalParicipants : 0 }} Total ({{ ppmCalc(enrollChartData) }}
      PPM)
    </div>
    <fusioncharts class="fusion-line-chart" slot="body" style="width: 100%;" :type="type" width="100%" :height="height" dataFormat="json" :dataSource="enrollChartData" dataEmptyMessage="No Data In" ref="enrollmentChart" v-if="enrollChartData.dataset && Object.keys(enrollChartData.dataset).length > 0" />
    <div slot="body" v-else class="align-center p-60">
      <div class="card-text-title no-data" v-if="dataLoaded">No Data In</div>
    </div>
  </chart-container>
</template>
<script>
import moment from "moment";
import _get from "lodash/get";
import _ from "lodash";
import { downloadCSV, lineColor, setVisForEnrollmentProgress, fusionChartCommon } from "../../services/visualization/recruitment";
import { convertMonthToTimestampsByMonth } from "../../services/visualization/utils";
import ChartContainer from "@/components/containers/chart-container";

const dataSources = {
  chart: {
    ...fusionChartCommon,
    paletteColors: lineColor().join(","),
    canvasBottomPadding: 3,
    canvasTopPadding: 10,
    showLegend: "1",
    xaxisname: "Month in the Study",
    yaxisname: "Monthly Enrollment"
  },
  categories: [{ category: [] }],
  dataset: []
};

export default {
  components: {
    ChartContainer
  },
  props: {
    rawData: { type: Object, default: () => {} },
    countrySelected: [Array, String],
    sitesSelected: [Array, String],
    monthSelected: [Object, Array],
    countryList: [Object, Array],
    allSitesList: [Object, Array],
    fromDate: [Object, String],
    toDate: [Object, String],
    zoomGraphValue: { type: String, default: "" },
    titleChart: { type: String, default: "" },
    specificSiteId: [Object, Array],
    dataLoaded: { type: Boolean, default: false },
    showTotalParticipant: { type: Boolean, default: true },
    xyAxisValue: [Object, String],
    containerId: { type: String, default: "" }
  },
  data() {
    return {
      zoomGraphValueChild: "",
      height: "250",
      tabIndex: 0,
      enrollTab: "Total",
      avgUnitTimeByMonthInStudies: null,
      totalUnitTimeByMonthInStudies: null,
      avgUnitTimeByMonthInCountries: null,
      initializeWeeks: null,
      type: "scrollline2d",
      tabList: ["Total", "Countries"],
      enrollChartData: dataSources
    };
  },
  watch: {
    specificSiteId(specificSiteId) {
      if (specificSiteId && specificSiteId.length === 0) {
        this.tabList.push("Sites");
        this.enrollChartData.chart.paletteColors = lineColor().join(",");
      } else {
        const palette = lineColor();
        palette.splice(0, 1);
        this.enrollChartData.chart.paletteColors = palette.join(",");
      }
    },
    rawData(value) {
      if(value){
        if (Object.keys(value).length == 0) {
        this.enrollChartData.dataset = [];
        this.enrollChartData.totalParicipants = 0;
        return;
        }
        this.avgUnitTimeByMonthInStudies = this.rawData.avgUnitTimeByMonthInStudies;
        const cloneForTotal = _.cloneDeep(this.rawData.avgUnitTimeByMonthInStudies);
        // Set Total monthlyWise
        this.totalUnitTimeByMonthInStudies = cloneForTotal.map(iw => {
          iw.y = iw.y2;
          return iw;
        });

        // Set the avg unit tine base on country
        this.avgUnitTimeByMonthInCountries = this.rawData.avgUnitTimeByMonthInCountries;
        this.initializeWeeks = this.avgUnitTimeByMonthInStudies.map(iw => iw.x);
        this.locations = _get(this.rawData, "locations", null);
        this.generateEnrollData();
      }
    },
    countrySelected() {
      this.generateEnrollData();
    },
    sitesSelected() {
      this.generateEnrollData();
    },
    zoomGraphValue: function(newVal) {
      this.zoomGraphValueChild = newVal;
      if (newVal == "") {
        this.height = "250px";
      }
    },
    tabIndex: function(newVal) {
      this.changeTab(this.tabList[newVal]);
    },
    monthSelected: function() {
      if (this.avgUnitTimeByMonthInCountries && this.totalUnitTimeByMonthInStudies) {
        this.generateEnrollData();
      }
    }
  },
  methods: {
    ppmCalc(data) {
      return data.totalParicipants ? Math.round(data.totalParicipants / data.categories[0].category.length) : 0;
    },
    changeTab(tab) {
      if (!this.rawData || (this.rawData && Object.keys(this.rawData).length == 0)) {
        this.enrollChartData = dataSources;
        this.enrollChartData.dataset = [];
        this.enrollChartData.totalParicipants = 0;
        return;
      }
      this.enrollTab = tab;
      this.generateEnrollData();
    },
    downloadCSVGraphs() {
      const header = ["Month in the Study"];
      const dataForCSV = [];
      const siteData = this.filterBySite(this.rawData.sitesStatusChangeData);
      const tmpDataSets = JSON.parse(JSON.stringify(this.enrollChartData.dataset));
      const tmpDataLabels = JSON.parse(JSON.stringify(this.enrollChartData.categories));
      tmpDataSets.map((row, i) => {
        row.data.map((rowLine, j) => {
          if (Object.keys(siteData).includes(row.seriesname) && row.filterType === "site") {
            const siteDate = moment()
              .month(tmpDataLabels[i].category[j].label.toUpperCase())
              .format("MM YYYY");
            const activeDate = `${siteData[row.seriesname].Active.month >= 10 ? siteData[row.seriesname].Active.month : "0" + siteData[row.seriesname].Active.month} ${siteData[row.seriesname].Active.year}`;
            const inActiveDate = siteData[row.seriesname].Inactive ? `${siteData[row.seriesname].Inactive.month >= 10 ? siteData[row.seriesname].Inactive.month : "0" + siteData[row.seriesname].Inactive.month} ${siteData[row.seriesname].Inactive.year}` : moment(new Date()).format("MM YYYY");
            if (siteDate < activeDate || siteDate > inActiveDate) {
              rowLine.y = "";
            }
          }
        });
      });
      this.enrollChartData.dataset.map(row => {
        header.push(row.seriesname);
      });
      dataForCSV[0] = [];
      dataForCSV[0].push("PPM");
      tmpDataSets.map(row => {
        let rowLength = 0;
        const ppm = row.data.reduce((sum, d) => {
          if (d.value !== "") {
            rowLength++;
            return Math.round(sum + d.value);
          } else {
            return sum;
          }
        }, 0);
        rowLength ? dataForCSV[0].push((ppm / rowLength).toFixed(2)) : dataForCSV[0].push(0);
      });
      tmpDataSets.map((row, i) => {
        row.data.map((rowLine, j) => {
          if (!dataForCSV[j + 1]) {
            dataForCSV[j + 1] = [];
            dataForCSV[j + 1].push(tmpDataLabels[i].category[j].label.toUpperCase(), Math.round(rowLine.value));
          } else {
            dataForCSV[j + 1].push(rowLine.value && Math.round(rowLine.value));
          }
        });
      });
      downloadCSV(this.titleChart, header, dataForCSV, [], this.specificSiteId);
    },
    zoomGraph(status) {
      if (status) {
        this.zoomGraphValueChild = true;
        this.height = "400";
        this.$emit("zoomEnabled");
      } else {
        this.zoomGraphValueChild = false;
        this.height = "250";
        this.$emit("zoomDisabled");
      }
    },
    generateEnrollData() {
      let dataForVisualizations = setVisForEnrollmentProgress(this.countrySelected, this.sitesSelected, this.monthSelected, this.avgUnitTimeByMonthInStudies, this.totalUnitTimeByMonthInStudies, this.locations, this.initializeWeeks, this.avgUnitTimeByMonthInCountries);
      if ((this.countrySelected && this.countrySelected.length === 0) || (this.sitesSelected && this.sitesSelected.length === 0)) {
        dataForVisualizations = [];
      } else {
        dataForVisualizations = _.filter(dataForVisualizations, dataForVisualization => {
          return dataForVisualization.filterType === this.enrollTab || dataForVisualization.filterType === "all";
        });
      }
      if (this.specificSiteId && this.specificSiteId.length > 0) {
        dataForVisualizations = _.filter(dataForVisualizations, dataForVisualization => {
          return dataForVisualization.filterType !== "all";
        });
      }
      /* =============================================== */
      // Get date label for chart base on selected month //
      /* =============================================== */
      const firstMonth = typeof this.monthSelected[0] === "number" ? this.monthSelected[0] : typeof this.monthSelected[0] === "string" ? convertMonthToTimestampsByMonth(this.monthSelected[0]) : convertMonthToTimestampsByMonth(this.monthSelected[0].display);
      const lastMonth = typeof this.monthSelected[1] === "number" ? this.monthSelected[0] : typeof this.monthSelected[1] === "string" ? convertMonthToTimestampsByMonth(this.monthSelected[1]) : convertMonthToTimestampsByMonth(this.monthSelected[1].display);
      const averageLabelChart = [];
      const updatedVisualizationChart = {};
      this.initializeWeeks = this.initializeWeeks || [];
      for (const item of this.initializeWeeks) {
        const thisMonth = convertMonthToTimestampsByMonth(item);

        if (thisMonth >= firstMonth && thisMonth <= lastMonth) {
          averageLabelChart.push({ label: item.toUpperCase() });
        }
      }
      if (this.enrollChartData.categories.length === 0) {
        this.enrollChartData.categories.push({ category: [] });
      }
      this.enrollChartData.categories[0].category = averageLabelChart;
      updatedVisualizationChart.dataset = dataForVisualizations;
      updatedVisualizationChart.totalParicipants = this.getTotalParticipants(updatedVisualizationChart.dataset);

      // Update chart
      this.enrollChartData = {
        ...this.enrollChartData,
        ...updatedVisualizationChart
      };
    },
    getTotalParticipants(dataVisualization) {
      let totalParticpants = 0;
      dataVisualization.forEach(dataSet => {
        if (dataSet.filterType !== "all") {
          dataSet.data.forEach(axisData => {
            totalParticpants += Math.round(axisData.value);
          });
        }
      });
      return totalParticpants;
    },
    filterBySite(sites) {
      const siteData = {};
      sites.map(site => {
        if (!siteData[site.site_name]) {
          siteData[site.site_name] = {
            Active: null,
            Inactive: null
          };
          siteData[site.site_name][site.site_status] = site;
        } else {
          siteData[site.site_name][site.site_status] = site;
        }
      });
      return siteData;
    }
  }
};
</script>
